module.exports = __webpack_public_path__ + "assets/rent-white.8a5d04a0.svg";